module.exports = __webpack_public_path__ + "static/media/04.8f1eff10.webp";